// Import custom transition functions from the Timedoor module.
// import { slideUp, slideDown, slideToggle, fadeOut, fadeIn, fadeToggle } from './modules/transitions';

// Import specific Bootstrap components for modular use in the project.
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Tooltip from 'bootstrap/js/dist/tooltip';
// import Tabs from 'bootstrap/js/dist/tab';

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

/**
 * Coding Standards
 * ===========================
 * 1. Functionality Splitting:
 *    - Create distinct, single-purpose functions to improve readability and reusability.
 * 2. Modular Imports:
 *    - Import only the required modules to reduce bundle size and enhance maintainability.
 * 3. Event Listeners:
 *    - Always wrap initialization code inside `DOMContentLoaded` to ensure the DOM is fully loaded.
 */

// function hello() {
//     const d = new Date()
//     let year = d.getFullYear()
//     console.log("%c ", "color: #FFFFFF; font-size: 20px"), 
//     console.log("%c©" + year + " Timedoor Indonesia.", "color: #FFFFFF; font-size: 25px"), 
//     console.log("%cAll rights reserved.", "color: #FFFFFF; font-size: 16px"), 
//     console.log("%c ", "color: #FFFFFF; font-size: 20px") 
// }

// function checkNavbarScrolled() {
//     const navbarPrimaryEl = document.querySelector('.custom-navbar')

//     if (navbarPrimaryEl) {
//         window.addEventListener('scroll', () => {
//             if (window.scrollY > 50) {
//                 navbarPrimaryEl.classList.add('scrolled')
//             } else {
//                 navbarPrimaryEl.classList.remove('scrolled')
//             }
//         })
//     }
// }

// function navbarMegaMenu() {
//     const childMenus = document.querySelectorAll('.menu-item-has-children');
//     const megaMenus = document.querySelectorAll('.menu-item-mega-menu');

//     if (!childMenus.length && !megaMenus.length) return;

//     // Combine both childMenus and megaMenus into one array
//     const menus = [...childMenus, ...megaMenus];

//     menus.forEach(menu => {
//         menu.addEventListener('click', (e) => {
//             e.preventDefault();

//             // Close other menus first
//             menus.forEach(menuIn => {
//                 if (menu !== menuIn) {
//                     const subMenu = menuIn.querySelector('.sub-menu');
//                     const megaMenu = menuIn.querySelector('.mega-menu');
//                     if (subMenu) fadeOut(subMenu, 200);
//                     if (megaMenu) slideUp(megaMenu);
//                 }
//             });

//             // Toggle the visibility of the clicked menu's sub-menu or mega-menu
//             const subMenu = menu.querySelector('.sub-menu');
//             const megaMenu = menu.querySelector('.mega-menu');
//             if (subMenu) fadeToggle(subMenu, 200, () => {
//                 menu.classList.toggle('is-open');
//             });
//             if (megaMenu) slideToggle(megaMenu, 400, () => {
//                 menu.classList.toggle('is-open');
//             });
//         });

//         // Add event listener for sub-menus and mega-menus to stop propagation
//         const subMenu = menu.querySelector('.sub-menu');
//         const megaMenu = menu.querySelector('.mega-menu');
//         if (subMenu) {
//             subMenu.addEventListener('click', (e) => {
//                 e.stopPropagation();
//             });
//         }
//         if (megaMenu) {
//             megaMenu.addEventListener('click', (e) => {
//                 e.stopPropagation();
//             });
//         }
//     });
// }
function navbarHeight() {
    const header = document.querySelector('.custom-navbar');
    if (!header) return;

    document.documentElement.style.setProperty(
        '--navbar-height',
        `${header.offsetHeight}px`
    );
}

function initBannerSwiper() {
    const swiper = new Swiper('.banner__swiper', {
        modules: [Navigation, Pagination, EffectFade, Autoplay],
        loop: true,
        speed: 800,
        autoplay: {
            delay: 3000,
            disableOnInteraction:false
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: '.banner-next',
            prevEl: '.banner-prev',
        },
        pagination: {
            el: '.banner-pagination__inner',
            type: 'fraction',
            formatFractionCurrent: (number) => {
                return number < 10 ? `0${number}` : number;
            },
            formatFractionTotal: (number) => {
                return number < 10 ? `0${number}` : number;
            },
            renderFraction: function (currentClass, totalClass) {
                return `
                    <span class="${currentClass}"></span>
                    <span>-</span>
                    <span class="${totalClass}"></span>
                `;
            },
        },
    });
}

function initCF7SuccessModal() {
    const wrapper = document.querySelector('[data-cf7="newsletter"]');
    if (!wrapper) return;

    const form = wrapper.querySelector('.wpcf7-form');
    if (!form) return;

    new MutationObserver(function () {
        const status = form.getAttribute('data-status');
        const btn = wrapper.querySelector('.wpcf7-submit');
        if (!btn) return;

        if (status === 'submitting') {
            btn.classList.add('is-loading');
            if (!wrapper.querySelector('.newsletter-spinner')) {
                const spinner = document.createElement('span');
                spinner.className = 'newsletter-spinner';
                btn.parentElement.style.position = 'relative';
                btn.insertAdjacentElement('afterend', spinner);
            }
        } else {
            btn.classList.remove('is-loading');
            const spinner = wrapper.querySelector('.newsletter-spinner');
            if (spinner) spinner.remove();
        }
    }).observe(form, { attributes: true, attributeFilter: ['data-status'] });

    document.addEventListener('wpcf7mailsent', function (e) {
        if (!wrapper.contains(e.target)) return;

        const modalElement = document.getElementById('successModal');
        if (!modalElement) return;

        Modal.getOrCreateInstance(modalElement).show();

        setTimeout(() => form.reset(), 300);
    });
}

function fallbackCopyText(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try { document.execCommand('copy'); } catch (_) {}
    document.body.removeChild(textarea);
}

function copyClipboard() {
    const copyButton = document.getElementById('copyLinkBtn');

    if (!copyButton) return;

    copyButton.addEventListener('click', function() {
        const url = window.location.href;
        const originalHTML = copyButton.innerHTML;

        function showFeedback() {
            copyButton.textContent = 'Copied!';
            setTimeout(() => { copyButton.innerHTML = originalHTML; }, 2000);
        }

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(showFeedback).catch(() => {
                fallbackCopyText(url);
                showFeedback();
            });
        } else {
            fallbackCopyText(url);
            showFeedback();
        }
    });
}

function initTooltips() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
        new Tooltip(el);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    navbarHeight();
    initBannerSwiper();
    initCF7SuccessModal();
    copyClipboard();
    initTooltips();
});

window.addEventListener('load', navbarHeight);
window.addEventListener('resize', navbarHeight);
